import { DatePipe } from '@angular/common';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public isLoggedIn = true;
  public selectedTheme = false;
  public envVariable = '';
  public isLoading = false;
  public userData: any;
  rateTableList: any;
  selectedColumn: number = 0;
  rateDateSource: any = [];
  rateOutputData: any = [];
  selectedItem: number = 0;
  checkedWithPrev = false;
  mineBtnEbaled: Boolean = false;
  emitCOunt = false;
  raSAve = false;
  rateTableSave = false;
  testSubsciber: any;
  matrixSubscriber: any;
  saveSubscrier: any;
  countryListArr: any;
  rateBackUpData: any = [];
  additionalBackup: any = [];
  copyActivity: boolean = false;
  exportPDFTableList: any = [];
  enableExport = false;
  raIsLoading = false;
  ftlRateChangeSub: any;
  ltlRateChangeSub: any;
  fixedRateChangeSub: any;
  infromationData: any;
  onRAvalueChanged: boolean = false;

  mineBtnEmit: EventEmitter<any> = new EventEmitter();
  matrixEmitter: EventEmitter<any> = new EventEmitter();
  additionalCostEmit: EventEmitter<any> = new EventEmitter();
  mautCostEmit: EventEmitter<any> = new EventEmitter();
  rateAgreementSaveemit: EventEmitter<any> = new EventEmitter();
  fileExportEmit: EventEmitter<any> = new EventEmitter();
  exportConversionEmitter: EventEmitter<any> = new EventEmitter();
  @Output() gsdbToTableEmit: EventEmitter<any> = new EventEmitter();
  @Output() imcsCodeBack: EventEmitter<any> = new EventEmitter();
  rateExportEmit: EventEmitter<any> = new EventEmitter();
  testEvtEMit: EventEmitter<any> = new EventEmitter();
  matrixDataEmit: EventEmitter<any> = new EventEmitter();
  headerLoadingEmitter: EventEmitter<any> = new EventEmitter();
  applyCahngeEmitForFTL: EventEmitter<any> = new EventEmitter();
  applyCahngeEmitForLTL: EventEmitter<any> = new EventEmitter();
  applyCahngeEmitForFixed: EventEmitter<any> = new EventEmitter();
  approveBtnClicked: boolean = false;

  constructor(private datePipe: DatePipe, private router: Router) {
    this.envVariable = environment.domain;
    this.onCheckSetItem();
  }

  onCheckSetItem(boo: boolean = false) {
    // console.log("OOOOOOOOOOOOOOOOOOOOOOOOOOOO");
    // if(boo){
    //   return;
    // }
    // const originalSetItem = sessionStorage.setItem;
    // sessionStorage.setItem = (key: string, value: string) => {
    //   if ((key === 'user-data' || key === 'authToken')) {
    //     alert("You cannot modify session data on this page.");
    //     console.error("Unauthorized attempt to modify session data.");
    //     // Invalidate session or log out the user
    //     sessionStorage.clear(); // Clear session storage
    //     this.router.navigate(['/login']); // Redirect to the login page
    //     return;
    //   }
    //   // Allow the original behavior for other cases
    //   return originalSetItem.call(sessionStorage, key, value);
    // }
  }

  specialCharacterValidator(control: any): { [key: string]: boolean } | null {
    const forbidden = /[<>`"'&]/.test(control.value); // Example regex to check for special characters
    return forbidden ? { forbiddenCharacters: true } : null;
  }

  setUserDetails(data: any) {
    this.userData = data;
    sessionStorage.setItem('user-data', JSON.stringify(data));
  }

  dateFormate(date: any) {
    let newDate = new Date(date);
    return this.datePipe.transform(newDate, 'yyyy-MM-dd');
  }

  onDateFromTimeZone(date: any) {
    let val = date?.split('T')[0];
    let rev = val?.split('-').reverse().join('/');
    return rev;
  }

  excelDateFormate(date: any) {
    let newDate = new Date(date);
    return this.datePipe.transform(newDate, 'dd/MM/yyyy');
  }

  getToday() {
    return this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  }

  escapeSingleQuotes(input: string): string {
    return input.replace(/'/g, "''").replace(/"/g, '&deq;');
  }
  deResingDoubleQuotess(input: string): string {
    return input ? input.replace(/&deq;/g, '"').replace(/''/g, "'") : '';
  }

  getDateWithNewValue(day: number, month: number, year: number) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + day);
    currentDate.setMonth(currentDate.getMonth() + month);
    currentDate.setFullYear(currentDate.getFullYear() + year);
    const nextDay = new Date(currentDate);
    return this.datePipe.transform(nextDay, 'dd/MM/yyyy');
    // return nextDay;
  }

  getDateWithSTDFormatNewValue(day: number, month: number, year: number) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + day);
    currentDate.setMonth(currentDate.getMonth() + month);
    currentDate.setFullYear(currentDate.getFullYear() + year);
    const nextDay = new Date(currentDate);
    // return this.datePipe.transform(nextDay, 'dd/MM/yyyy');
    return nextDay;
  }

  getWithFormatToday() {
    let d = new Date();
    let time = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
    let date = this.datePipe.transform(d, 'dd/MM/yyyy');
    return date + ' ' + time;
  }

  getSelectedCount(data: any, key: string) {
    return data.filter((item: any) => item[key]).length;
  }

  setRateTableData(data: any, no: number, type: string) {
    let outputData: any = [];
    this.checkedWithPrev = false;
    this.rateOutputData = this.rateOutputData.filter(
      (item: any) => item.orderId !== no
    ); // removing the current data to update new data
    let rateItem = this.rateTableList[no];
    let rateTableData = this.rateDateSource[no];

    data.forEach((item: any) => {
      let obj = {
        RateTableID:
          rateItem.RateTableID === 0 || !rateItem.RateTableID
            ? null
            : rateItem.RateTableID,
        RateTableName: rateItem.RateTableName,
        RateAgreementTableID:
          this.rateTableList[0].RateAgreementTableID === 0 ||
          !this.rateTableList[0].RateAgreementTableID
            ? null
            : this.rateTableList[0].RateAgreementTableID,
        RateTableType:
          type === 'ftl'
            ? 'FTL Matrix'
            : type === 'ltl'
            ? 'LTL Matrix'
            : 'FTL(Fixed Price) Matrix',
        BidPackID:
          rateTableData.BidPackID === 0 ? null : rateTableData.BidPackID,
        // CarrierID: rateTableData.CarrierID === 0 || !rateTableData.CarrierID? 0:rateTableData.CarrierID,
        TransportModeID:
          rateTableData.TransportModeID === 0 || !rateTableData.TransportModeID
            ? null
            : rateTableData.TransportModeID,
        RateTableTypeID: type === 'ftl' ? 42 : type === 'ltl' ? 44 : 43,

        FuelEscalatorFlag: rateTableData.FuelEscalatorFlag,
        FuelEscalatorVersion: this.escapeSingleQuotes(
          rateTableData.FuelEscalatorVersion
            ? rateTableData.FuelEscalatorVersion
            : ''
        ),
        FuelCostBaseline:
          rateTableData.FuelCostBaseline === 0 ||
          !rateTableData.FuelCostBaseline
            ? 0
            : rateTableData.FuelCostBaseline,
        DataSourceForFuelPrice: this.escapeSingleQuotes(
          rateTableData.DataSourceForFuelPrice
            ? rateTableData.DataSourceForFuelPrice
            : ''
        ),
        CountryForFuelPriceID:
          rateTableData.CountryForFuelPriceID === 0 ||
          !rateTableData.CountryForFuelPriceID
            ? 0
            : rateTableData.CountryForFuelPriceID,

        FuelCostBreakdown: rateTableData.FuelCostBreakdown
          ? +rateTableData.FuelCostBreakdown
          : 0,
        FuelTrigger: rateTableData.FuelTrigger ? +rateTableData.FuelTrigger : 0,
        FuelEscalatorComment: this.escapeSingleQuotes(
          rateTableData.FuelEscalatorComment
            ? rateTableData.FuelEscalatorComment
            : ''
        ),
        ExcludingVAT: rateTableData.ExcludingVAT,
        RateChange:
          rateTableData.RateChange === 0 || !rateTableData.RateChange
            ? null
            : rateTableData.RateChange,
        Remarks: this.escapeSingleQuotes(
          rateTableData.Remarks ? rateTableData.Remarks : ''
        ),
        IMCSSiteCode: rateTableData.IMCSSiteCode
          ? rateTableData.IMCSSiteCode
          : '',

        LTLWeight: type === 'ltl' ? item.LTLWeight : null,
        Distance: type === 'ltl' ? item.Distance : null,
        LTLCost: type === 'ltl' ? item.LTLCost : null,

        TrailerRateType: type === 'ftl' ? item.TrailerRateType : null,
        FTLWeight: type === 'ftl' ? item.FTLWeight : null,
        FTLCost: type === 'ftl' ? item.FTLCost : null,

        CountryID: type === 'ftl' ? rateTableData.CountryID : null,
        MautCost: type === 'ftl' ? rateTableData.MautCost : null,
        AdditionalCostItem:
          type === 'ftl' ? rateTableData.AdditionalCostItem : null,
        AdditionalCost: type === 'ftl' ? rateTableData.AdditionalCost : null,

        FixedFTLDistance: type === 'fixed' ? +item.FixedFTLDistance : null,
        Service: type === 'fixed' ? item.Service : null,
        FixedFTLTrailerRateType:
          type === 'fixed' ? item.FixedFTLTrailerRateType : null,
        FixedFTLCost: type === 'fixed' ? item.FixedFTLCost : null,

        FixedFTLCountryID:
          type === 'fixed' ? rateTableData.FixedFTLCountryID : null,
        FixedFTLMautCost:
          type === 'fixed' ? rateTableData.FixedFTLMautCost : null,
        FixedFTLAdditionalCostItem:
          type === 'fixed' ? rateTableData.FixedFTLAdditionalCostItem : null,
        FixedFTLAdditionalCost:
          type === 'fixed' ? rateTableData.FixedFTLAdditionalCost : null,

        UserEmail: this.userData?.Email,
        orderId: no,
      };
      outputData.push(obj);
    });
    this.rateOutputData = [...this.rateOutputData, ...outputData];
  }

  updateRateTableValues(data: any, type: string) {
    if (type === 'ftl') {
      this.rateOutputData = this.rateOutputData
        .filter((item: any) => item.orderId === this.selectedItem)
        .map((item: any) => ({ ...item, ...data[this.selectedItem] }));
    }
  }

  updateDataToDB() {
    const filteredObject = Object.keys(
      this.rateDateSource[this.selectedItem]
    ).reduce((obj: any, key: any) => {
      if (this.rateOutputData[this.selectedItem]?.hasOwnProperty(key)) {
        obj[key] = this.rateDateSource[this.selectedItem][key];
        if (
          (key === 'BidPackID' ||
            key === 'TransportModeID' ||
            key === 'CountryForFuelPriceID') &&
          this.rateDateSource[this.selectedItem][key] === 0
        ) {
          obj[key] = null;
        }
      }
      return obj;
    }, {});
    this.rateOutputData.map((obj: any) => {
      if (obj.orderId === this.selectedItem) {
        Object.assign(obj, filteredObject);
      }
    });
  }

  updateValueToRateTable(fieldKey: any, no: number) {
    this.rateOutputData.forEach((i: any) => {
      if (i.orderId === no) {
        i[fieldKey] = this.rateDateSource[no][fieldKey];
      }
    });
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Return formatted date as yyyy-mm-dd
  }

  restrictFloatInput(input: any) {
    const value = input.value;
    const regex = /^\d+(\.\d{0,2})?$/;

    if (!regex.test(value)) {
      input.value = value.slice(0, -1);
    }
  }

  roundOffInput(input: any) {
    const value = input.value;
    const roundedValue = parseFloat(value).toFixed(2);
    input.value = roundedValue;
  }

  onMautcountry(cost: any, item: any) {
    if (item) {
      let len = item.split(',').length;
      let mautCountry = item
        .split(',')
        .map((value: any) =>
          this.countryListArr.find(
            (obj: any) => obj.CountryName === value && obj.ISMaut
          )
        )
        .filter((obj: any) => obj !== undefined)
        .map((obj: any) => obj.CountryID)
        .join(','); //item?.split(",")
      let Value: any = (
        cost ? cost.split(',') : Array.from({ length: len }).fill(0)
      ).join(',');
      return { item: mautCountry, cost: Value };
    }
    return [];
  }

  onAdditionVal(cost: any, item: any) {
    let additionalCosts = null;
    additionalCosts = cost.split(',');
    let additionalCostItems = item?.split(',');
    let costOutarr = [];
    // if(this.rateId !== 0){
    if (additionalCostItems && additionalCostItems.length > 0) {
      costOutarr = additionalCostItems.map((item: any, index: any) => ({
        charge: item,
        rate: additionalCosts[index],
      }));
      return costOutarr;
    }
    return [];
  }

  exportTableFormatForFTL(res: any, ind: number) {
    let rateTypeMapping: any = {};
    let truckType = ['euro', 'mega', 'jumbo', 'giga'];
    const uniqueRateTypes = new Set();
    res.forEach((obj: any) => {
      uniqueRateTypes.add(obj.TrailerRateType);
    });
    uniqueRateTypes?.forEach((rateType: any) => {
      let key = rateType
        .toLowerCase()
        .replace(/ - /g, '-')
        .replace(/ km rate/g, '')
        .replace(/ /g, '-');

      // Perform specific replacements
      key = key
        .replace('single-trip-inbound', 'inbound')
        .replace('single-trip-return', 'return')
        .replace('round-trip', 'roundtrip');
      rateTypeMapping[rateType] = key;
    });
    const transformedArray = res.reduce((acc: any, obj: any) => {
      const weightRange = obj.Weight.split('-');
      const key = `${weightRange[0]}-${weightRange[1]}`;

      // Initialize the object with dynamic rate types if it doesn't exist
      if (!acc[key]) {
        acc[key] = {
          from: weightRange[0],
          to: weightRange[1],
        };
        uniqueRateTypes.forEach((rateType: any) => {
          acc[key][rateTypeMapping[rateType]] = 0;
        });
      }

      const rateTypeKey: any = rateTypeMapping[obj.TrailerRateType];
      if (rateTypeKey) {
        acc[key][rateTypeKey] = obj.FTLMatrixCost;
      }
      return acc;
    }, {});

    let finalArray = Object.values(transformedArray);
    let dbDataSource = finalArray;

    if (dbDataSource.length)
      dbDataSource = dbDataSource.sort(
        (a: any, b: any) => Number(a.from) - Number(b.from)
      );
    if (!res[0]) {
      return;
    }
    // calculate addition cost
    let additionalCosts = ('' + res[0].AdditionalCost)?.split(',');
    let additionalCostItems = res[0].AdditionalCostItem?.split(',');

    let costOutarr = [];
    if (additionalCostItems && additionalCostItems.length > 0) {
      costOutarr = additionalCostItems.map((item: any, index: any) => ({
        charge: item,
        rate: additionalCosts[index],
      }));
    }

    let mautCountry = res[0].MautCountry?.split(',');
    let mautCountryCost: any = ('' + res[0].MautCountryCost)?.split(',');
    let mautOutArr = [];
    if (mautCountry && mautCountry.length > 0) {
      mautOutArr = mautCountry.map((item: any, index: any) => ({
        country: item,
        rate: mautCountryCost[index],
      }));
    }
    let obj = {
      data: dbDataSource,
      type: 'ftl',
      maut: mautOutArr,
      charge: costOutarr,
      name: this.rateDateSource[ind],
      effectiveDate: this.infromationData.EffectiveDate,
    };
    this.exportPDFTableList[ind] = obj;
  }

  exportTableFormatForFIxed(res: any, ind: number) {
    let rateTypeMapping: any = {};
    let truckType = ['euro', 'mega', 'jumbo', 'giga'];
    const uniqueRateTypes = new Set();
    res.forEach((obj: any) => {
      uniqueRateTypes.add(obj.TrailerRateType);
    });
    uniqueRateTypes?.forEach((rateType: any) => {
      let key = rateType
        .toLowerCase()
        .replace(/ - /g, '-')
        .replace(/ km rate/g, '')
        .replace(/ /g, '-');

      // Perform specific replacements
      key = key
        .replace('single-trip-inbound', 'inbound')
        .replace('single-trip-return', 'return')
        .replace('round-trip', 'roundtrip');
      rateTypeMapping[rateType] = key;
    });
    const transformedArray = res.reduce((acc: any, obj: any) => {
      const order = obj.Distance;

      if (!acc[order]) {
        acc[order] = {
          service: obj.Service,
          // orderId: FixedFTLMatrixID
        };
        uniqueRateTypes.forEach((rateType: any) => {
          acc[order][rateTypeMapping[rateType]] = 0;
        });
      }
      const rateTypeKey: any = rateTypeMapping[obj.TrailerRateType];
      if (rateTypeKey) {
        acc[order][rateTypeKey] = obj.FTLMatrixCost;
      }
      return acc;
    }, {});

    let finalArray = Object.values(transformedArray);
    let dbDataSource = finalArray;
    if (dbDataSource.length)
      dbDataSource = dbDataSource.sort(
        (a: any, b: any) => Number(a.from) - Number(b.from)
      );
    if (!res[0]) {
      return;
    }
    // calculate addition cost
    let additionalCosts = ('' + res[0].AdditionalCost)?.split(',');
    let additionalCostItems = res[0].AdditionalCostItem?.split(',');

    let costOutarr = [];
    if (additionalCostItems && additionalCostItems.length > 0) {
      costOutarr = additionalCostItems.map((item: any, index: any) => ({
        charge: item,
        rate: additionalCosts[index],
      }));
    }

    let mautCountry = res[0].MautCountry?.split(',');
    let mautCountryCost: any = ('' + res[0].MautCountryCost)?.split(',');
    let mautOutArr = [];
    if (mautCountry && mautCountry.length > 0) {
      mautOutArr = mautCountry.map((item: any, index: any) => ({
        country: item,
        rate: mautCountryCost[index],
      }));
    }

    let obj = {
      data: dbDataSource,
      type: 'fixed',
      maut: mautOutArr,
      charge: costOutarr,
      name: this.rateDateSource[ind],
      effectiveDate: this.infromationData.EffectiveDate,
    };
    this.exportPDFTableList[ind] = obj;
  }

  exportTableFormatForLTL(res: any, ind: number) {
    const uniqueWeights: any = [...new Set(res.map((obj: any) => obj.Weight))];
    let displayedCol = ['from', 'to', ...uniqueWeights];
    const updatedArray = res.map((obj: any) => {
      const { Weight, Cost, ...rest } = obj;
      return { LTLWeight: Weight, LTLCost: Cost, ...rest };
    });

    const transformedArray = res.map((obj: any) => {
      const weightRange = obj.Weight.split('-');
      const distanceRange = obj.Distance.split('-');

      return {
        from: distanceRange[0],
        to: distanceRange[1],
        [weightRange.join('-')]: obj.Cost,
      };
    });

    const finalArray = Object.values(
      transformedArray.reduce((acc: any, obj: any) => {
        const key = `${obj.from}-${obj.to}`;
        if (!acc[key]) {
          acc[key] = {
            from: obj.from,
            to: obj.to,
          };
        }
        Object.assign(acc[key], obj);
        return acc;
      }, {})
    );

    let dbDataSource = finalArray.sort(
      (a: any, b: any) => Number(a.from) - Number(b.from)
    );
    let orderkeys = displayedCol.sort((a, b) => {
      const isANumber = !isNaN(parseInt(a));
      const isBNumber = !isNaN(parseInt(b));

      if (isANumber && isBNumber) {
        return parseInt(a) - parseInt(b);
      } else if (isANumber) {
        return -1;
      } else if (isBNumber) {
        return 1;
      } else {
        return a.localeCompare(b);
      }
    });

    displayedCol = orderkeys.filter((item) => !['from', 'to'].includes(item));
    displayedCol = ['from', 'to', ...displayedCol];

    let obj = {
      data: dbDataSource,
      type: 'ltl',
      maut: [],
      charge: [],
      name: this.rateDateSource[ind],
      effectiveDate: this.infromationData.EffectiveDate,
    };
    this.exportPDFTableList[ind] = obj;
  }

  onBPRegion(item: any, key: string) {
    const originCountryArray = item[key]
      .split(',')
      .filter((value: any) => value.trim() !== '');
    const uniqueOriginCountryArray = [...new Set(originCountryArray)];
    return uniqueOriginCountryArray.join(',');
  }
}
